import { Divider, IcInfo, IconButton, Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import type { ServiceDetailPerformance } from '@musinsa/services-curator';
import { ProductCuratorLinkInfoBottomSheet } from '../components/ProductCuratorLinkInfoBottomSheet';

const StatItem = ({ label, value }: { label: string; value: string }) => (
  <div className="flex items-center justify-between py-1">
    <Typography size="13" weight="regular" colorScheme="black">
      {label}
    </Typography>
    <Typography size="13" weight="regular" colorScheme="black" className="text-right">
      {value}
    </Typography>
  </div>
);

interface ProductCuratorLinkSectionProps {
  goodsData?: ServiceDetailPerformance;
  isConfirmed?: boolean;
}

export const ProductCuratorLinkSection = ({
  goodsData,
  isConfirmed = false,
}: ProductCuratorLinkSectionProps) => {
  const { service } = useDeviceInfo();

  // 데이터가 없을 때 기본값 사용
  const data = goodsData || {
    earnings: { total: '0원' },
    orderAmount: { total: '0원', direct: '0원', indirect: '0원', exclusive: '0원' },
    orderCount: { total: 0, direct: 0, indirect: 0, exclusive: 0 },
    visitCount: 0,
  };

  return (
    <div className="bg-white px-4">
      {/* 섹션 제목 */}
      <div className="flex items-center gap-0.5 py-3">
        <Typography size="18" weight="medium" colorScheme="black">
          상품 제휴 링크 실적
        </Typography>
        <ProductCuratorLinkInfoBottomSheet>
          <IconButton asChild className="flex cursor-pointer" size="size16x16">
            <IcInfo />
          </IconButton>
        </ProductCuratorLinkInfoBottomSheet>
      </div>

      <div className="pb-3 pt-1">
        {/* 통계 항목들 - 실제 데이터 사용 */}
        <StatItem label="방문" value={`${data.visitCount.toLocaleString()}회`} />
        <StatItem label="결제 건" value={`${data.orderCount.total.toLocaleString()}건`} />
        {service === SERVICE.MUSINSA && (
          <StatItem
            label="무신사 단독 상품 직접 기여 결제 건"
            value={`${data.orderCount.exclusive.toLocaleString()}건`}
          />
        )}
        <StatItem
          label="직접 기여 결제 건"
          value={`${data.orderCount.direct.toLocaleString()}건`}
        />
        <StatItem
          label="간접 기여 결제 건"
          value={`${data.orderCount.indirect.toLocaleString()}건`}
        />
        <StatItem label="상품 결제 금액" value={data.orderAmount.total} />
        {service === SERVICE.MUSINSA && (
          <StatItem
            label="무신사 단독 상품 직접 기여 결제 금액"
            value={`${data.orderAmount.exclusive.toLocaleString()}`}
          />
        )}
        <StatItem label="직접 기여 상품 결제 금액" value={data.orderAmount.direct} />
        <StatItem label="간접 기여 상품 결제 금액" value={data.orderAmount.indirect} />
        <StatItem label={isConfirmed ? '확정 수익' : '예상 수익'} value={data.earnings.total} />
      </div>

      <div className="py-3">
        <Divider variant="line" />
      </div>
    </div>
  );
};
